module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile-wrapper"
  }, [_c('div', {
    staticClass: "mobile"
  }, [_c('iframe', {
    staticClass: "demo-page",
    attrs: {
      "src": './examples.html#' + _vm.$route.path,
      "frameborder": "0"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-117a2ba0!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/components/mobile.vue
// module id = 166
// module chunks = 2